import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DeepSeaSmallPiratesSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_SMALL_PIRATES;
}

export default DeepSeaSmallPiratesSalvageableTileEntity;
